// Module
var code = "<template> <require from=\"app/cm/admin/referral/referred-by\"></require> <referred-by></referred-by> </template> ";
// Exports
module.exports = code;